import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
    CmsConfig,
    GlobalMessageService,
    I18nModule,
    NotAuthGuard,
    provideDefaultConfig,
    UrlModule,
    WindowRef,
} from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';
import { LoginFormComponentService, LoginFormModule } from '@spartacus/user/account/components';
import { VscaAuthService } from '../../../../../../../core/auth/user-auth/facade/vsca-auth.service';
import { VscaLoginFormComponentService } from './vsca-login-form-component.service';
import { VscaLoginFormComponent } from './vsca-login-form.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ReturningCustomerLoginComponent: {
          component: VscaLoginFormComponent,
          guards: [NotAuthGuard],
          providers: [
            {
              provide: LoginFormComponentService,
              useClass: VscaLoginFormComponentService,
              deps: [VscaAuthService, GlobalMessageService, WindowRef],
            },
          ],
        },
      },
    } as CmsConfig),
  ],
  declarations: [VscaLoginFormComponent],
  exports: [VscaLoginFormComponent],
})
export class VscaLoginFormModule extends LoginFormModule {}
